// themes.js
// https://www.w3schools.com/colors/colors_picker.asp
// https://www.w3schools.com/colors/colors_hexadecimal.asp

import colors from "./theme_colors";


const theme = (main, responsiveKey, dimentions, currentDarkTheme) => {

	colors.system_mode = (!!currentDarkTheme?"dark":"light");
	colors.opposite_mode = colors[(!!currentDarkTheme?"light":"dark")];
	colors.mode = colors[colors.system_mode];

  const _web = (main.platform_os === "web");
  const _ios = (main.platform_os === "ios");
  // Prevent multiple reloads.
  if (!!main.theme && main.theme?.respKey === responsiveKey) {
    return main.theme;
  }

  const sizes = {
    icon: {
      tiny: 12,
      small: 16,
      default: 18,
      large: 22,
      xlarge: 26,
    }
  }

  const borderRadius = 10;  // For Cards and containers, not Inputs.
  const inputBorderRadius = 5;  // For Cards and containers, not Inputs.

  const containers = {
    cardBlock: {
      width: "100%",
      maxWidth: 325,
    },
    pageWrapper: {
      position: "relative",
      flexGrow: 1,
    },
    pageTitleBar: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      flexShrink: 1,
      flexWrap: "wrap",
      justifyContent: "space-between",
      paddingBottom: 20,
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 20,
    },
    pageTitleText: {
      alignItems: "center",
      color: colors.mode.textColor,
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      flexGrow: 1,
      fontSize: 24,
      fontWeight: "500",
      justifyContent: "flex-start",
      zIndex:10,
    },
    pageTitle: {
      alignItems: "baseline",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      flexGrow: 1,
      fontSize: 24,
      fontWeight: "500",
      justifyContent: "flex-start",
      paddingBottom: 20,
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 20,
    },
    pageSubtitle: {  // only `inline`
      color: colors.mode.textColor2,
      flexGrow: 1,
      fontSize: 12,
      fontWeight: "300",
      paddingBottom: 10,
      paddingLeft: 10,
    },
    pageSubtitleInline: {  // only `inline`
      color: colors.mode.textColor2,
      fontSize: 12,
      fontWeight: "300",
      paddingBottom: 0,
      paddingLeft: 20,
    },
    containerLiner: {
      alignItems: "stretch",
      color: colors.mode.textColor,
      display: "flex",
      flexDirection: "column",
      flexShrink: 1,
      justifyContent: "flex-start",
    },
    container: {
      alignItems: "stretch",
      // borderColor: colors.mode.containerBorderColor,
      // borderRadius: borderRadius,
      // borderStyle: "solid",
      // borderWidth: 1,
      color: colors.mode.textColor,
      display: "flex",
      flexDirection: "column",
      flexShrink: 1,
      justifyContent: "flex-start",
      marginBottom: 30,
      // marginLeft: (main.platform_os !== "web" ? 10 : "invalid"),   // These two attributes were moved out to Main.css
      // marginRight: (main.platform_os !== "web" ? 10 : "invalid"),  // These two attributes were moved out to Main.css
      minHeight: 100,
      overflow: "hidden",
      paddingBottom: 15,
      position: "relative",
    },
    containerTitle: {
      alignItems: "center",  // alignItems: "baseline",  // FOR SOME ODD REASON "baseline" CRASHES THE MOBILE APP.
      alignSelf: "stretch",
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      flexShrink: 1,
      flexWrap: "wrap",
      fontSize: 20,
      fontWeight: "700",
      height: 60,
      justifyContent: "space-between",
      paddingBottom: 20,
      // width: "100%",  // This fixes iOS bug where it's not growing to parent width.
    },
    containerTitleText: {
      alignItems: "center",
      color: colors.mode.textColor,
      flexWrap: "wrap",
      fontSize: 20,
      lineHeight: (_web ? 20 : 21),
      fontWeight: "500",
    },
    containerTitle2Text: {
      alignItems: "center",
      color: colors.mode.textColor3,
      flexWrap: "wrap",
      fontSize: 16,
      lineHeight: (_web ? 20 : 21),
      fontWeight: "400",
    },
    containerTitleInput: {
      color: colors.mode.textColor,
      flexWrap: "wrap",
      fontSize: 20,
      fontWeight: "700",
      marginBottom: -8,
      marginTop: -8,
      marginLeft: -10,
      paddingHorizontal: 8,
    },
    containerSubtitle: {
      color: colors.mode.textColor,
      flexGrow: 1,
      fontSize: 12,
      fontWeight: "300",
      marginBottom: 10,
      marginLeft: 20,
    },
    containerSubtitleInline: {
      alignSelf: "center",  // (_web ? "baseline" : "center"),
      color: colors.mode.textColor,
      fontSize: 12,
      fontWeight: "300",
      marginBottom: 0,
      paddingLeft: 20,
    },


    containerColumn: {
      alignItems: "stretch",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      flexShrink: 1,
      justifyContent: "flex-start",
    },
    containerRow: {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      flexShrink: 1,
      justifyContent: "stretch",
    },
    sectionWrapperRow: {
      alignItems: "flex-end",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      paddingHorizontal: 20,
      paddingVertical: 15,
    },
    sectionWrapper: {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      flexWrap: (_web ? "wrap" : "unset"),  // iOS BUG: This forces same-line in iOS, weird.
      justifyContent: "flex-start",
      maxWidth: "100%",
      paddingHorizontal: 20,
      paddingVertical: 15,
    },
    subsectionWrapper: {
      alignItems: "flex-start",
      flexDirection: "column",
      flexGrow: 0,
      flexShrink: 0,
      // flexWrap: "wrap",  // Don't wrap in columns. Causes unexpected behavior.
      justifyContent: "flex-start",
      padding: 0,
    },
    subsectionWrapperRow: {
      alignItems: "flex-start",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 0,
      flexWrap: "wrap",
      justifyContent: "flex-start",
      padding: 0,
    },
    sectionTitle: {
      color: colors.mode.textColor,
      flexGrow: 1,
      flexShrink: 1,
      fontSize: 16,
      fontWeight: "500",
      marginBottom: 10,
      paddingLeft: 0,
    },
    sectionTitleText: {
      color: colors.mode.textColor,
      fontSize: 16,
      fontWeight: "500",
    },
    sectionSubtitle: {
      color: colors.mode.textColor,
      fontSize: 12,
      flexGrow: 1,
      flexShrink: 1,
      fontWeight: "300",
      marginBottom: 10,
      paddingLeft: 10,
    },
    sectionSubtitleInline: {
      color: colors.mode.textColor,
      fontSize: 12,
      fontWeight: "300",
      marginBottom: 0,
      paddingLeft: 10,
    },
    sectionBody: {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      flexShrink: 1,
      flexWrap: "wrap",
      justifyContent: "center",
      minHeight: 34,
    },
    sectionBodyRow: {
      alignItems: "flex-start",
      alignSelf: "stretch",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      maxWidth: "100%",
      minHeight: 34,
    },
    flexRowAlignTop: {
      alignItems: "flex-start",
      alignSelf: "stretch",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      minHeight: 34,
    },
    flexRowAlignCenter: {
      alignItems: "center",
      alignSelf: "stretch",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      minHeight: 34,
    },
    nestedRow: {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "flex-start",
    },

    sectionLoadingOverlay: {
      backgroundColor: "white",
      flexDirection: "column",
      justifyContent: "flex-start",
      opacity: 1,
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      top: 0,
      transition: "opacity 0ms",
    },
    sectionLoadingOverlayFade: {
      backgroundColor: "white",
      flexDirection: "column",
      justifyContent: "flex-start",
      opacity: 0,
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      top: 0,
      transition: "opacity 500ms",
    },

    sectionDataWrapper: {
      alignItems: "flex-start",
      flexDirection: "column",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      paddingHorizontal: 20,
      paddingVertical: 15,
    },
    sectionGridWrapper: {
      alignItems: "flex-start",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
    },
    sectionInputBlock: {
      alignItems: "flex-start",
      alignSelf: "stretch",
      flexDirection: "row",
      justifyContent: "flex-start",
    },
    sectionFormBlocksWrapper: {
      alignItems: "flex-start",
      alignSelf: "stretch",
      display: "flex",
      flexBasis: "auto",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
    },
    sectionFormBlockVerticalWrapper: {
      alignItems: "flex-start",
      alignSelf: "stretch",
      display: "flex",
      flexBasis: "auto",
      flexDirection: "column",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    sectionFormBlock: {
      alignItems: "flex-start",
      display: "flex",
      flexBasis: "auto",
      flexDirection: "column",
      flexGrow: 1,
      flexShrink: 1,
      flexWrap: "wrap",
      justifyContent: "flex-start",
      marginRight: 30,
      minHeight: 34,
    },
    sectionFormBlockTitle: {
      alignSelf: "stretch",
      borderBottomColor: colors.monoLight,
      borderBottomWidth: 1,
      color: colors.mode.textColor,
      fontSize: 16,
      fontWeight: "500",
      lineHeight: 18,
      marginBottom: 8,
      paddingBottom: 8,
      paddingLeft: 0,
    },
    sectionFormBlockTitleText: {
      color: colors.mode.textColor,
      fontSize: 16,
      fontWeight: "500",
      lineHeight: 18,
      paddingLeft: 0,
      textAlign: "center",
    },
    sectionGridColumnLabel: {
      alignItems: "flex-start",
      flexGrow: 0,
      fontSize: 18,
      fontWeight: "500",
      justifyContent: "center",
      minWidth: 20,
      padding: 4,
    },
    sectionGridItemLabelView: {
      alignItems: "flex-end",
      flexDirection: "column",
      justifyContent: "flex-start",
      width: 120,
    },
    sectionGridItemLabelText: {
      color: colors.monoDark,
      fontWeight: "600",
      paddingRight: 2,
      paddingVertical: 6,
      textAlign: "right",
    },
    sectionGridItemText: {
      fontWeight: "400",
      marginLeft: 2,
      minHeight: 8,
      paddingLeft: 4,
      paddingRight: 0,
      paddingTop: 6,
    },
    sectionGridItem: {
      alignItems: "flex-start",
      flexDirection: "column",
      flexGrow: 0,
      fontWeight: "400",
      justifyContent: "flex-start",
      minWidth: 20,
    },
    sectionGridFormItem: {
      alignItems: "flex-start",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "flex-start",
      minWidth: 20,
    },
    sectionGridItemNote: {
      fontSize: 11,
      fontWeight: "200",
    },


    tileRow: {
      alignItems: "stretch",
      alignSelf: "stretch",
      backgroundColor: colors.mode.containerBackgroundColor,
      borderRadius: 0,
      display: "flex",
      flexDirection: "column",
      flexGrow: 0,
      flexShrink: 0,
      justifyContent:"space-between",
      padding: 15,
    },
    tileRowNested: {
      alignItems: "stretch",
      alignSelf: "stretch",
      backgroundColor: colors.mode.containerBackgroundColor,
      borderRadius: 4,
      display: "flex",
      flexDirection: "column",
      // flexGrow: 1,
      // flexShrink: 1,
      justifyContent: "stretch",
      padding: 10,
      position: "relative",
    },
    tileChip: {
      background: "#e3e9e6",
      borderRadius: 4,
      color: "#666666",
      marginBottom: 2,
      marginRight: 5,
      paddingHorizontal: 9,
      padding: 6,
      textDecoration: "none",
      verticalAlign: "middle",
      fontSize: 12,
    },
    tiles: {
      outerContainer: {
        alignItems: "flex-start",
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        justifyContent: "stretch",
        overflow: "auto",
        paddingHorizontal: 6,
        paddingBottom: 6,
        paddingTop: 6,
        position: "relative",
        rowGap: 16,
      },
      fieldsColumn: {
        alignItems: "stretch",
        display: "flex",
        flexDirection: "column",
        // flexGrow: 1,
        // flexShrink: 1,
        justifyContent: "flex-start",
        paddingbottom: 8,
      },
      sectionHeader: {
        alignItems: "stretch",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      },
      sectionHeaderKey: {
        alignItems: "stretch",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        paddingTop: 4,
        color: colors.mode.textAccent,
        fontSize: 14,
        fontWeight: 800,
      },
      sectionHeaderTitle: {
        alignItems: "stretch",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        paddingTop: 4,
        color: colors.mode.textColor2,
        fontSize: 24,
      },
      sectionRow: {
        alignSelf:"stretch",
        alignItems: "flex-start",
        borderTopColor: colors.mode.menuBorderColor,
        borderTopStyle: "solid",
        borderTopWidth: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        marginTop: 12,
        paddingTop: 12,
      },
      fieldRow: {
        alignItems: "flex-start",
        borderTopColor: colors.mode.menuBorderColor,
        borderTopStyle: "solid",
        borderTopWidth: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        marginTop: 8,
        paddingTop: 8,
      },
      fieldRowLabel: {
        alignItems: "flex-start",
        display: "flex",
        flexBasis: 110,   // Width (110+10=120) to match the profile icon width+mariginRight of 120.
        flexDirection: "row",
        justifyContent: "flex-start",
        marginRight: 10,  // Width (110+10=120) to match the profile icon width+mariginRight of 120.

        color: colors.mode.textColor2,
        lineHeight: 19,
        fontSize: 15,
        fontWeight: "500",
      },
      fieldRowValue: {
        alignItems: "flex-start",
        display: "flex",
        flexBasis: "min-content",
        flexDirection: "column",
        flexGrow: 1,
        flexShrink: 1,
        flexWrap: "wrap",
        justifyContent: "flex-start",

        color: colors.mode.textAccent,
        lineHeight: 19,
        fontSize: 15,
      },
    },


    scrollViewDivider: {
      borderTopColor: colors.monoDisabled,
      borderTopWidth: 1,
    },
    scrollViewLabel: {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      padding: 6,
    },
    scrollViewLabelText: {
      color: colors.monoDark,
      fontWeight: "600",
      lineHeight: 22,
    },
    scrollViewContainer: {
      height: 300,
      maxWidth: 600,
      borderWidth: 2,
      borderColor: colors.mode.containerBorderColor,
    },
    scrollViewRow: {
      // backgroundColor: colors.mode.baseBackground,
      borderColor: colors.mode.containerBorderColor,
      borderTopWidth: 1,
      borderTopColor: colors.listRowDiv,  // colors.mode.TouchableOpacityHover,
      flexDirection: "row",
      alignItems: "flex-start",
      paddingVertical: 5,
      paddingHorizontal: 6,
      paddingRight: 26,
    },
    scrollViewRowCategory: {
      // backgroundColor: colors.mode.baseMedium2,
      flexDirection: "row",
      alignItems: "flex-start",
      padding: 4,
    },
    scrollViewRowCategoryText: {
      fontWeight: "600",
    },
    scrollViewRowSubcategory: {
      // backgroundColor: colors.mode.baseMedium3,
      flexDirection: "row",
      alignItems: "flex-start",
      padding: 4,
      paddingLeft: 14,
    },
    scrollViewRowSubcategoryText: {
      fontWeight: "600",
    },
  };

  // const tables = {
  //   celBdr: { borderBottomWidth: 1, borderLeftWidth: 1, borderColor: colors.mode.baseMedium },
  //   celTpBdr: { borderTopWidth: 1, borderColor: colors.mode.baseMedium },
  //   celRtBdr: { borderRightWidth: 1, borderColor: colors.mode.baseMedium },
  //   celBmBdr: { borderBottomWidth: 1, borderColor: colors.mode.baseMedium },
  //   tableTopperLabel: {
  //     backgroundColor: colors.mode.base,
  //     borderColor: colors.mode.base,
  //     borderLeftWidth: 1,
  //     borderRightWidth: 1,
  //     borderTopWidth: 1,
  //     flexDirection: "row",
  //     justifyContent: "center",
  //   },

  //   tableBorder: { borderWidth: 1, borderColor: colors.mode.baseMedium },
  //   tableTopper: { flexDirection: "row" },
  //   tableHead: { flexDirection: "row", backgroundColor: colors.mode.baseMedium },
  //   tableFoot: { flexDirection: "row", backgroundColor: colors.mode.baseFooter },
  //   tableFootNumeric: { flexDirection: "row", backgroundColor: colors.mode.baseFooter, fontVariant: "tabular-nums" },
  //   tableHeadText: { marginVertical: 0, paddingLeft: 6, paddingRight: 6, paddingBottom: 6, paddingTop: 6, fontWeight: "600", textAlign: "center"},
  //   tableHeadNumeric: { marginVertical: 0, paddingLeft: 6, paddingRight: 6, paddingBottom: 6, paddingTop: 6, fontWeight: "600", textAlign: "right", fontVariant: "tabular-nums" },
  //   tableCol: { flexDirection: "column", backgroundColor: colors.mode.baseBackground },
  //   tableRow: { flexDirection: "row", backgroundColor: colors.mode.baseBackground },
  //   tableRowHover: { flexDirection: "row", backgroundColor: colors.mode.baseBackgroundHover },
  //   tableText: { marginVertical: 0, paddingLeft: 8, paddingRight: 8, paddingBottom: 6, paddingTop: 6 },
  //   tableNumeric: { marginVertical: 0, paddingLeft: 8, paddingRight: 8, paddingBottom: 6, paddingTop: 6, textAlign: "right", fontVariant: "tabular-nums" },
  // };

  // const simpleGrid = {
  //   gridTitle: { fontSize: 16, fontWeight: 500 },
  //   gridFootNumeric: { flexDirection: "row", backgroundColor: colors.mode.baseFooter, fontVariant: "tabular-nums" },
  //   gridHeadText: { marginVertical: 0, paddingLeft: 6, paddingRight: 6, paddingBottom: 6, paddingTop: 6, fontWeight: "600" },
  //   gridHeadNumeric: { marginVertical: 0, paddingLeft: 6, paddingRight: 6, paddingBottom: 6, paddingTop: 6, fontWeight: "600", textAlign: "right", fontVariant: "tabular-nums" },
  //   gridCol: { flexDirection: "column", backgroundColor: colors.mode.baseBackground },
  //   gridRow: { flexDirection: "row", backgroundColor: colors.mode.baseBackground },
  //   gridRowHover: { flexDirection: "row", backgroundColor: colors.mode.baseBackgroundHover },
  //   gridText: { marginVertical: 0, paddingLeft: 8, paddingRight: 8, paddingBottom: 6, paddingTop: 6 },
  //   gridNumeric: { marginVertical: 0, paddingLeft: 8, paddingRight: 8, paddingBottom: 6, paddingTop: 6, textAlign: "right", fontVariant: "tabular-nums" },
  // };

  const reactNativePopupMenuStyles = {
    rnpmMenuTrigger: {
      triggerOuterWrapper: {
        borderRadius: "50%",
        overflow: "hidden",
      },
      triggerTouchable: {
        underlayColor: colors.mode.base,
        activeOpacity: 0.1,
      }
    },
    rnpmMenuOptions: {
      optionsContainer: {
        backgroundColor: colors.mode.containerBackgroundColor3,
        borderRadius: 6,
        marginLeft: -36,
        overflow: "hidden",
        width: "auto",
      },
      optionsWrapper: {
        backgroundColor: colors.mode.containerBackgroundColor3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "stretch",
      }
    },
    rnpmMenuOption: {
      optionWrapper: {
        paddingLeft: 6,
        paddingRight: 16,
      },
      optionTouchable: {
        underlayColor: colors.mode._baseLight,
        activeOpacity: 1,
      }
    },
    rnpmMenuOptionText: {
      // backgroundColor: colors.mode.containerBackgroundColor3,
      // display: "flex",
      // flexDirection: "column",
      // justifyContent: "stretch",
      fontSize: 18,
      paddingHorizontal: 5,
    },
    rnpmMenuOptionIcon: {
      color: colors.mode.textColor4,
      fontSize: 18,
      height: 18,
      width: 18,
      marginBottom: -2,
      marginRight: 6,
      marginLeft: 0,
    },
  };

  const moreMenu = {
    moreMenuButton: {
      backgroundColor: colors.mode.containerBackgroundColor3,
      borderColor: colors.mode.containerBackgroundColor3,
      borderRadius: "50%",
      height: 32,
      marginHorizontal: 0,
      marginVertical: 0,
      paddingHorizontal: 0,
      paddingTop: 0,
      paddingVertical: 0,
      width: 32,
      zIndex: 1010,
    },
    moreMenuButtonIcon: {
      color: colors.mode.textColor3,
      fontSize: 22,
      lineHeight: 30,
    },
    moreMenuWrapper: {
      alignItems: "stretch",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      position: "absolute",
      right: 0,
      top: 32,
      zIndex: 1011,
    },
    moreMenuWrapperLeft: {
      alignItems: "stretch",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      position: "absolute",
      right: 32,
      top: -5,
      zIndex: 1011,
    },
    moreMenuArrowWrapper: {
      borderColor: colors.mode.containerBorderColor,
      borderWidth: 0,
      height: 10,
      position: "absolute",
      right: 11,
      top: -2,
      transform: [{rotate:"45deg"}],
      width: 10,
    },
    moreMenuArrowWrapperLeft: {
      borderColor: colors.mode.containerBorderColor,
      borderWidth: 0,
      height: 10,
      position: "absolute",
      right: -3,
      top: 16,
      transform: [{rotate:"45deg"}],
      width: 10,
    },
    moreMenuArrow: {
      backgroundColor: colors.mode.containerBorderColor,
      height: 10,
      width: 10,
    },
    moreMenuItemsWrapper: {
      boxShadow: "-2px 3px -3px 10px #00000080",
      alignItems: "flex-start",
      backgroundColor: colors.mode.containerBackgroundColor3,
      borderColor: colors.mode.containerBorderColor,
      borderWidth: 1,
      borderTopWidth: 3,
      borderRadius: 15,
      display: "flex",
      flexDirection: "column",
      justifyContent: "stretch",
      overflow: "hidden",
      zIndex: 1012,
    },
    moreMenuItemBgColor: colors.mode.containerBackgroundColor3,
    moreMenuItemBgHoverColor: colors.mode.containerBackgroundColor,
    moreMenuItem: {
      alignItems: "center",
      alignSelf: "stretch",
      backgroundColor: colors.mode.containerBackgroundColor3,
      borderBottomColor: "#cccccc",
      borderBottomWidth: 1,
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      height: 32,
      justifyContent: "flex-start",
      padding: 0,
      paddingLeft: 10,
      paddingRight: 12,
      verticalAlign: "top",
    },
    moreMenuItemText: {
      alignItems: "stretch",
      color: colors.mode.menuTextColor,
      display: "flex",
      flexDirection: "row",
      fontSize: 14,
      justifyContent: "center",
      verticalAlign: "top",
    },
  };

  const webOnlyCursor = (_web ? { cursor: "pointer" } : {});
  const webOnlyCursorBlocked = (_web ? { cursor: "not-allowed" } : {});
  const webOnlyPlaceholderTextColor = (_web ? { placeholderTextColor: colors.mode.placeholderTextColor, outline: "none" } : {});

  const textInputStyle = {
    backgroundColor: colors.mode.inputBackgroundColor,
    // borderColor: colors.mode.containerBorderColor,
    borderColor: colors.mode.inputBorderColor,
    // borderColor: "#cccccc",
    borderRadius: inputBorderRadius,
    // borderWidth: 2,
    borderWidth: 1,
    // fontSize: 14,
    Color: colors.mode.inputTextColor,
    fontSize: 16,
    // height: 25,
    // marginVertical: 2,
    maxWidth: "100%",
    paddingHorizontal: 8,
    paddingVertical: 6,
    // padding: 8,
    textAlign: "left",


    // backgroundColor: "#ffffff",
    // borderWidth: 1,
    // borderColor: "#cccccc",
    // borderRadius: _theme.inputBorderRadius,
    // padding: 8,
    // fontSize: 16,
    // width: "100%",

    ...webOnlyPlaceholderTextColor,
  };

  const primaryFontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
  const fixedWidthFontFamily = "Monaco";


  const theme = {
    ...{

      responsiveKey: responsiveKey,
      respHeight: dimentions.height,
      respWidth: dimentions.width,
      appMaxWidth: 1398,  // To allow for 1px border (1398+2=1400) for left + right borders to both be visible without being hidden.

      fontFamily: primaryFontFamily,
      fixedWidthFontFamily: fixedWidthFontFamily,

      colors: colors,

      sizes: sizes,

      borderRadius: borderRadius,
      inputBorderRadius: inputBorderRadius,

      // boxShadow: {shadowOffset:{width:2,height:2},shadowOpacity:0.5,shadowRadius:10},
      boxShadow: "0px 2px 2px 10px #00000080",

      cursorPointer: webOnlyCursor,
      cursorBlocked: webOnlyCursorBlocked,

      ccInputWrapper: {
        ...textInputStyle,
        flexDirection: "column",
        height: 24,
        overflow: "hidden",
        paddingHorizontal: 4,
        paddingVertical: 0,
      },
      ccFontStyle: {
        backgroundColor: colors.white,
        color: colors.monoDark,
        fontFamily: fixedWidthFontFamily,
        fontSize: 14,
        // fontSmoothing: "antialiased",
        height: 24,               // This is ignored on StripeElement Base Style: https://stripe.com/docs/js/appendix/style
        letterSpacing: 0.05,
        lineHeight: 20,
        paddingLeft: 4,           // This is ignored on StripeElement Base Style: https://stripe.com/docs/js/appendix/style
      },
      //// https://css-tricks.com/thats-just-how-i-scroll/
      //// https://css-tricks.com/books/greatest-css-tricks/scroll-shadows/
      // scrollerIndicator: {
      //   background: `
      //     linear-gradient( white 30%, rgba(255, 255, 255, 0) ) center top,
      //     linear-gradient( rgba(255, 255, 255, 0), white 70% ) center bottom,
      //     radial-gradient( farthest-side at 50% 0, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0) ) center top,
      //     radial-gradient( farthest-side at 50% 100%, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0) ) center bottom
      //   `,
      //   backgroundRepeat: "no-repeat",
      //   backgroundSize: "100% 40px, 100% 40px, 100% 14px, 100% 14px",
      //   backgroundAttachment: "local, local, scroll, scroll",
      // },

      rowLabelSmall: {
        alignSelf: "stretch",
        backgroundColor: colors.mode.baseLight,
        flexDirection: "row",
        height: 16,
        justifyContent: "flex-start",
        paddingLeft: 10,
        paddingRight: 20,
        paddingTop: 2,
      },

      innerScrollable: {
        maxWidth: "calc(100vw - 62px)",
        overflow: "scroll",
      },

      progressText: {
        color: colors.mode.base,
        fontSize: 18,
        textAlign: "center",
      },
      errorText: {
        color: colors.caution,
        fontSize: 18,
        textAlign: "center",
      },
      fieldLabelRow: {
        alignItems: "center",
        flexDirection: "row",
        flexGrow: 1,
        flexShrink: 1,
        justifyContent: "space-between",
      },
      fieldLabel: {
        color: colors.mode.textColor,
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        flexShrink: 1,
        fontSize: 12,
        lineHeight: 12,
        fontWeight: "300",
        paddingLeft: 8,
      },
      fieldLabelLarge: {
        color: colors.mode.textColor,
        display: "flex",
        flexDirection: "row",
        fontSize: 16,
        lineHeight: 20,
        flexGrow: 1,
        flexShrink: 1,
        fontWeight: "500",
        margin: 0,
        paddingBottom: 0,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 0,
        verticalAlign:"top",
      },
      fieldLabel2: {
        color: colors.mode.textColor,
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        flexShrink: 1,
        fontSize: 14,
        fontWeight: "300",
        paddingLeft: 8,
      },
      fieldLabelDesc: {
        color: colors.mode.textColor,
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        flexShrink: 1,
        fontSize: 10,
        fontWeight: "300",
        paddingLeft: 8,
      },
      fieldLabelInline: {
        color: colors.mode.textColor,
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        flexShrink: 1,
        fontSize: 12,
        fontWeight: "300",
        paddingLeft: 8,
      },
      textInput: {
        ...textInputStyle,
      },
      pickerInput: {
        ...textInputStyle,
        paddingHorizontal: 4,
      },
      inlineTextInputLabel: {
        ...textInputStyle,
        color: colors.mode.textColor,
        fontWeight: "600",
        textAlign: "right",
        fontSize: 14,
        height: 29,
        margin: 0,
        marginVertical: 0,
        paddingLeft: 4,
      },
      inlineTextInput: {
        ...textInputStyle,
        fontSize: 14,
        height: 29,
        margin: 0,
        marginVertical: 0,
        paddingLeft: 4,
      },
      textInputRead: {
        ...textInputStyle,
        borderColor: colors.monoLight,
        borderRadius: inputBorderRadius,
        borderWidth: 1,
        fontSize: 16,
        marginVertical: 2,
        paddingHorizontal: 7,
        paddingVertical: 7,
        textAlign: "left",
      },
      textInputLarge: {
        ...textInputStyle,
        height: 32,
        fontSize: 18,
        marginBottom: 6,
        marginTop: 6,
      },
      textInputSmall: {
        ...textInputStyle,
        borderWidth: 1,
        height: 22,
        fontSize: 14,
        lineHeight: 14,
        marginBottom: 6,
        marginTop: 6,
      },
      numericInput: {
        ...textInputStyle,
        textAlign: "right",
      },
      cellTextInput: {
        ...textInputStyle,
        borderRadius: inputBorderRadius,
        flexGrow: 1,
        fontSize: 14,
        marginVertical: 0,
        paddingVertical: 4,
      },
      cellNumericInput: {
        ...textInputStyle,
        borderRadius: inputBorderRadius,
        flexGrow: 1,
        fontSize: 14,
        marginVertical: 0,
        paddingVertical: 4,
        textAlign: "right",
      },
      textInputDisabled: {
        backgroundColor: colors.monoDisabled,
        borderColor: colors.monoLight,
        borderRadius: inputBorderRadius,
        borderWidth: 2,
        fontSize: 16,
        marginVertical: 2,
        padding: 6,
        textAlign: "left",
        ...webOnlyPlaceholderTextColor
      },
      inputWrapper: {
        alignItems: "flex-start",
        flexDirection: "column",
        justifyContent: "flex-start",
        paddingRight: 16,
        paddingBottom: 8,
      },
      inputWrapperRow: {
        alignItems: "flex-start",
        flexDirection: "row",
        flexWrap: "wrap",
        maxWidth:"100%",
        paddingRight: 16,
      },
      inputWrapperVertical: {
        alignItems: "flex-start",
        flexDirection: "column",
        maxWidth: "100%",
        paddingTop: 5,
      },
      inlineSubmitStatus: {
        alignItems: "center",
        color: colors.success,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        minHeight: 22,
        paddingHorizontal: 20,
        width: "auto",
      },
      linkText: {
        alignItems: "center",  // Because "Baseline" can cause errors in mobile...
        color: colors.mode.base,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        fontSize: 14,
        fontWeight: "400",
        justifyContent: "flex-start",
        ...webOnlyCursor,
      },
      linkTextHover: {
        alignItems: "center",  // Because "Baseline" can cause errors in mobile...
        color: colors.mode.baseHover,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        fontSize: 14,
        fontWeight: "400",
        justifyContent: "flex-start",
        ...webOnlyCursor,
      },
      baseText: {
        alignItems: "center",  //This is vertical alignment -- Because "Baseline" can cause errors in mobile...
        color: colors.mode.base,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        fontSize: 14,
        fontWeight: "500",
        justifyContent: "flex-start",
        // ...webOnlyCursor,
      },
      warnText: {
        alignItems: "center",  // Because "Baseline" can cause errors in mobile...
        color: colors.warn,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        fontSize: 14,
        fontWeight: "500",
        justifyContent: "flex-start",
        // ...webOnlyCursor,
      },
      cautionText: {
        alignItems: "center",  // Because "Baseline" can cause errors in mobile...
        color: colors.caution,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        fontSize: 14,
        fontWeight: "500",
        justifyContent: "flex-start",
        // ...webOnlyCursor,
      },
      successText: {
        alignItems: "center",  // Because "Baseline" can cause errors in mobile...
        color: colors.success,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        fontSize: 14,
        fontWeight: "500",
        justifyContent: "flex-start",
        // ...webOnlyCursor,
      },
      darkText: {
        color: colors.monoDark,
        fontSize: 14,
        fontWeight: "300",
      },
      normalText: {
        color: colors.mode.textColor,
        fontSize: 14,
        fontWeight: "300",
      },
      disabledText: {
        color: colors.mode.textColor,
        fontSize: 14,
        fontWeight: "300",
      },
      hidden: {
        display: "none",
      },
    },
    iconButtonStyle: {
      alignItems: "flex-end",
      backgroundColor: "#ffffff",
      borderColor: "#ffffff",
      borderRadius: inputBorderRadius,
      borderWidth: 1,
      flexDirection: "row",
      flexGrow: 1,
      height: 16,
      justifyContent: "center",
      position: "absolute",
      right: 4,

      // boxShadow: {shadowColor: "rgba(0,0,0,1)",shadowOffset:{height:1,width:1},shadowOpacity:0.4,shadowRadius:4},
      boxShadow: "0px 1px 1px 4px #00000080",
      top: 7,
      width:16,
    },
    ...containers,
    // ...tables,
    // ...simpleGrid,
    ...moreMenu,
    ...reactNativePopupMenuStyles,
  };


  // These override any above styles when implemented in modules.
  theme.externalUserPagesStyles = {
    container: {
      flexDirection: "row",
      justifyContent: "center",
    },
    wrapper: {
      flexDirection: "column",
      justifyContent: "flex-start",
      paddingTop: 160,
      width: 260,
    },
    headerRow: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      height: 60,
      marginBottom: 10,
    },
    headerLogo: {
      height: 26,
      width: 26,
    },
    headerTitle: {
      color: colors.mode.base,
      fontSize: 20,
      marginLeft: 6,
    },
    optionLinksContainer: {
      paddingTop: 40,
    },
    optionLinkRow: {
      alignContent: "center",
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      minHeight: 35,
      justifyContent: "flex-end",
      width: "auto",
    },
  };

  theme.effects = {
    linkColorOnHover: (e) => { e.target.style.color = colors.mode.baseHover; },
    linkColorOffHover: (e) => { e.target.style.color = colors.mode.base; },
    linkSuccessOnHover: (e) => { e.target.style.color = colors.successHover; },
    linkSuccessOffHover: (e) => { e.target.style.color = colors.success; },
    linkCautionOnHover: (e) => { e.target.style.color = colors.cautionHover; },
    linkCautionOffHover: (e) => { e.target.style.color = colors.caution; },
    linkOnHover: (e) => { e.target.style.textDecorationLine = "underline"; },
    linkOffHover: (e) => { e.target.style.textDecorationLine = "none"; },
    // getTargetPosition: (el) => {
    //   try {
    //       var offsetHeight = el.offsetHeight;
    //       var offsetWidth = el.offsetWidth;
    //       var offsetTopTotal = 0;
    //       var offsetLeftTotal = 0;
    //       offsetTopTotal += el.offsetTop;
    //       offsetLeftTotal += el.offsetLeft;
    //       while(el !== null) {
    //           offsetTopTotal += el.offsetTop;
    //           offsetLeftTotal += el.offsetLeft;
    //           el = el.offsetParent;
    //       }
    //       var returnObj = {
    //           top: offsetTopTotal,
    //           left: offsetLeftTotal,
    //           height: offsetHeight,
    //           width: offsetWidth
    //       };
    //       console.log("returnObj =", returnObj);
    //       return returnObj;
    //   } catch (err) {
    //       console.log("Error in SearchItem -> getTargetPosition(el) Error =",err,el);
    //       return {top:-1,left:-1,height:-1,width:-1};
    //   }
    // },
  }

  return theme

};

export default theme;
